export const SIDEBAR_WIDTH = 240;
export const sideBarList = []